import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { getStatusClass } from './chirpResultsHelpers'
import BankChangeCustomerDetails from './BankChangeCustomerDetails'

const BankChangeApprovalSummary = ({ status, customerData, oldAccountLastFour, oldAccountRouting }) => (
  <div className="box mb-3 ml-2 mr-2 pt-4 pb-2">
    <div className="columns mb-0">
      <div className="column is-12">
        <div className="is-flex is-justify-content-space-between is-align-items-center mb-2">
          <h4 className="title is-6 mb-0">
            <FontAwesomeIcon icon={faCreditCard} className="mr-2" />
            Bank Change Manager Approval
          </h4>
          <div className="is-flex is-align-items-center">
            <span className="has-text-weight-bold mr-2">STATUS:</span>
            <span className={`tag is-large has-text-weight-bold ${getStatusClass(status)}`}>
              {status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Not Set'}
            </span>
          </div>
        </div>
        <BankChangeCustomerDetails
          customerData={customerData}
          oldAccountLastFour={oldAccountLastFour}
          oldAccountRouting={oldAccountRouting}
          variant="grid"
        />
      </div>
    </div>
  </div>
)

export default BankChangeApprovalSummary
